import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { validate } from '../../util/validate';
import './index.less';

const needHolderFix = (navigator.userAgent.toUpperCase().indexOf('MSIE 9') >= 0);

// 普通文本框
class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value,
            holderStyle: {},
            error: ''
        };
        this.setValue = this.setValue.bind(this);
        this.onRef = this.onRef.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.inputValue = props.value;
    }

    setValue(e) {
        const { onChange } = this.props;
        const { value } = this.state;
        const inputValue = e.target.value;

        if (value == inputValue) {
            return;
        }

        this.setState({
            value: inputValue
        });
        this.inputValue = inputValue;

        const error = this.props.hasOwnProperty('rules') ? validate(inputValue, this.props.rules) : false;

        this.setState({
            error
        });

        onChange && onChange(inputValue, error);
    }

    onSelect(e) {
        const { onClick } = this.props;
        onClick && onClick(e);
    }

    componentWillReceiveProps(nextProps) {
        const { value } = nextProps;
        if (typeof value !== 'undefined' && value != this.inputValue) {
            this.setState({
                value
            });
        }
    }

    getInput() {
        return this.input;
    }

    onRef(ref) {
        this.input = ref;
        if (ref && needHolderFix) {
            const computedStyle = getComputedStyle(ref);
            const holderStyle = {};
            holderStyle.width = computedStyle.width;
            if (computedStyle.lineHeight !== 'normal') {
                holderStyle.lineHeight = computedStyle.lineHeight;
            }
            holderStyle.left = `${parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.borderLeftWidth) + parseFloat(computedStyle.marginLeft)}px`;
            holderStyle.top = `${parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.borderTopWidth) + parseFloat(computedStyle.marginTop)}px`;
            this.setState({ holderStyle });
        }
    }

    render() {
        const props = this.props;
        const {
            tag, placeholder, width, height
        } = props;
        const {
            value, limit, holderStyle, error
        } = this.state;

        const thisProps = { ...props };
        delete thisProps.value;
        delete thisProps.tag;

        const sizeStyle = {};
        let input;
        if (width) {
            sizeStyle.width = `${width}px`;
        }
        if (height) {
            sizeStyle.height = `${height}px`;
        }
        if (tag === 'textarea') {
            input = (
                <label className="u-textarea">
                    <textarea style={sizeStyle} ref={this.onRef} {...thisProps} value={value} onChange={this.setValue} />
                    <span className="ipt-err">{error}</span>
                </label>
            );
        } else {
            input = (
                <label className="u-input">
                    <input style={sizeStyle} ref={this.onRef} {...thisProps} className={`${error ? 'f-tpl-err' : ''}  ${thisProps.hasOwnProperty('className') ? thisProps.className : ''}`} value={value} onChange={this.setValue} onClick={this.onSelect} />
                    <span className="ipt-err">{error}</span>
                </label>
            );
        }

        if (needHolderFix && placeholder) {
            return (
                <label className="ipt-holderfix">
                    {!value && <span className="ipt-holder" style={holderStyle} unselectable="on">{placeholder}</span>}
                    {input}
                </label>
            );
        }
        return input;
    }
}

const Textarea = props => (
    <Input tag="textarea" {...props} />
);

const rulesUnion = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
]);

const valueUnion = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
]);

Input.propTypes = {
    onChange: PropTypes.func,
    value: valueUnion,
    tag: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    onClick: PropTypes.func,
    rules: rulesUnion,
    width: PropTypes.number,
    height: PropTypes.number
};

export default Input;
export { Textarea };



// WEBPACK FOOTER //
// ./client/component/input/index.js